import { useSelector } from "react-redux";

import { getCurrentProject } from "fond/project";
import { MultiProject, Project, Store } from "fond/types";

/**
 * Plucks the current project from the Redux store.
 * This is used to access the current project in various components.
 * It can return either a single Project or a MultiProject.
 */
export const useCurrentProject = (): Project | MultiProject => {
  const project = useSelector((state: Store) => getCurrentProject(state.project));
  return project;
};
